export const Instagram = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0032 6.82118C10.0304 6.82118 6.82591 10.0264 6.82591 14.0001C6.82591 17.9737 10.0304
       21.1789 14.0032 21.1789C17.976 21.1789 21.1805 17.9737 21.1805 14.0001C21.1805 10.0264 17.976
       6.82118 14.0032 6.82118ZM14.0032 18.6673C11.4359 18.6673 9.33702 16.5742 9.33702 14.0001C9.33702
       11.4259 11.4296 9.33285 14.0032 9.33285C16.5768 9.33285 18.6693 11.4259 18.6693 14.0001C18.6693
       16.5742 16.5705 18.6673 14.0032 18.6673ZM23.1481 6.52753C23.1481 7.45847 22.3985 8.20198 21.474
       8.20198C20.5433 8.20198 19.8 7.45223 19.8 6.52753C19.8 5.60284 20.5496 4.85308 21.474 4.85308C22.3985
       4.85308 23.1481 5.60284 23.1481 6.52753ZM27.9017 8.22697C27.7955 5.98396 27.2833 3.99712 25.6405
       2.36016C24.0039 0.723198 22.0175 0.210868 19.775 0.098405C17.4638 -0.0328017 10.5364 -0.0328017
       8.22513 0.098405C5.98887 0.20462 4.00247 0.716951 2.35963 2.35391C0.716791 3.99087 0.210821 5.97771
       0.098383 8.22072C-0.0327943 10.5325 -0.0327943 17.4614 0.098383 19.7732C0.204574 22.0162 0.716791
       24.003 2.35963 25.64C4.00247 27.2769 5.98262 27.7893 8.22513 27.9017C10.5364 28.0329 17.4638 28.0329
       19.775 27.9017C22.0175 27.7955 24.0039 27.2832 25.6405 25.64C27.2771 24.003 27.7893 22.0162 27.9017
       19.7732C28.0329 17.4614 28.0329 10.5387 27.9017 8.22697ZM24.9159 22.2536C24.4287 23.4782 23.4854
       24.4216 22.2549 24.9152C20.4121 25.6462 16.0396 25.4775 14.0032 25.4775C11.9668 25.4775 7.58799
       25.64 5.7515 24.9152C4.52718 24.4279 3.58395 23.4844 3.09048 22.2536C2.35963 20.4104 2.52829
       16.0369 2.52829 14.0001C2.52829 11.9632 2.36588 7.58343 3.09048 5.74654C3.57771 4.52194 4.52093
       3.57851 5.7515 3.08492C7.59423 2.35391 11.9668 2.5226 14.0032 2.5226C16.0396 2.5226 20.4184 2.36016
       22.2549 3.08492C23.4792 3.57226 24.4224 4.5157 24.9159 5.74654C25.6467 7.58968 25.4781 11.9632
       25.4781 14.0001C25.4781 16.0369 25.6467 20.4167 24.9159 22.2536Z"
        fill="#051C2C"
      />
    </svg>
  )
}
